import { Component } from '@angular/core';

@Component({
  selector: 'app-retailer-international',
  templateUrl: './retailer-international.component.html',
  styleUrls: ['./retailer-international.component.scss']
})
export class RetailerInternationalComponent {
  Loader = false
  countryFlagImg = ""
  flagCountries = []
  internationalCountryCode = ""
  regionCode: string
  countries = [];
  CountryValue = "Select Country"

  constructor() {

  }

  async countryFlagFilter(number) {
    console.log(this.Loader)
    var filter
    filter = this.flagCountries.filter(country => country.code == number)
    if (filter.length > 0) {
      this.countryFlagImg = filter[0].flag
      this.internationalCountryCode = filter[0].iso
      this.regionCode = filter[0].iso
      await this.GetSingleCountry(filter[0].code)
    }
  }

  GetSingleCountry(countryCode) {
    console.log(countryCode.value)
    var selectedCountry = this.countries.find(m => m.code == countryCode)
    console.log(selectedCountry)
    this.CountryValue = selectedCountry.name
    this.GetProviders(selectedCountry.iso)
  }

  async GetProviders(id) {
    // this.Loader = true
    // console.log(id)
    // this.CountryIso = id

    // const selectedCountry = this.countries.find(country => country.iso === id);
    // this.CountryName = selectedCountry.label
    // this.intlprovidersOption = []
    // this.customService.GetProviders(id).subscribe((res: any) => {
    //   console.log(res)
    //   this.providers = res
    //   this.Loader = false
    //   this.intlprovidersOption = []
    //   for (let i = 0; i <= this.providers.length; i++) {
    //     this.intlprovidersOption.push({ value: this.providers[i].providerCode, label: this.providers[i].name, label2: this.providers[i].logoUrl })
    //   }
    //   console.log(this.intlprovidersOption)
    //   this.Loader = false
    // })
    // this.Loader = false
  }
}
